export const isEqualCuePoint = (existingCue, newCue) => {
  if (!existingCue || !newCue) {
    return false;
  }

  return (
    existingCue.startTime === newCue.startTime &&
    existingCue.endTime === newCue.endTime &&
    existingCue.payload === newCue.payload
  );
};
